module.exports = __webpack_public_path__ + "static/media/business-ui.22c96a09.jpg";